"use client";

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "next/image";
import { motion } from "framer-motion";
import "./BusinessGrowthSection.scss";

const BusinessGrowthSection = ({ data }) => {
  const { title, description, growthCards } = data;
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: -120,
      scale: 0.8,
    },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      rotate:
        typeof window !== "undefined" && window.innerWidth <= 768
          ? 0
          : growthCards[index].rotate,

      transition: {
        duration: 0.9,
        delay: index * 0.25,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };
  return (
    <section className="business-growth-section">
      <Container>
        {/* Header */}
     
          <Row className="align-items-start">
            <Col lg={7}>
              <h2 className="main-title">{title}</h2>
            </Col>

            <Col lg={5}>
              <p className="main-description">{description}</p>
            </Col>
          </Row>
      

        {/* Cards */}
        <div className="growth-cards-wrapper">
          {growthCards.map((card, index) => (
            <motion.div
              key={card.id}
              className="growth-card"
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div className="card-content">
                <h4>{card.title}</h4>

                <div className="card-footer">
                  <p>{card.description}</p>

                  <div className="card-image">
                    <Image
                      src={card.image}
                      alt={card.title}
                      fill
                      className="image"
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default BusinessGrowthSection;
